<template>
  <div class="blockuser" v-if="seen">
    <div class="notify" :class="{ notify_succes: success }">
      <span class="close-box" @click="close">
        <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
          <path
            fill="#FC6D6C"
            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
          />
        </svg>
      </span>
      <div v-if="!success">
        <div class="send-div" @keypress="send_question">
          <span
            style="
              font-size: 14px;
              margin-bottom: 1em;
              text-decoration: underline;
            "
          >
            Enter your email address to receive a reset link
          </span>
          <span>
            <label>Email Address</label>
            <input
              type="text"
              placeholder="Enter email address"
              v-model="email"
              @keypress="hideError"
            />
            <span class="error" v-if="error.email"
              >Please enter your email address</span
            >
            <span class="error" v-if="message">{{ message }}</span>
            <span class="error" v-if="exist">{{ exist }}</span>
            <span class="send-btn" @click="sendquestion">Send</span>
          </span>
          <span class="loader" v-if="loader"
            >Please wait...
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid"
              viewBox="0 0 100 100"
              width="40px"
              height="40px"
              class="lds-dual-ring"
              style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
            >
              <circle
                cx="50"
                cy="50"
                fill="none"
                stroke-linecap="round"
                stroke="#039aed"
                r="30"
                stroke-dasharray="41.41592653589793 41.41592653589793"
                stroke-width="8"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  calcMode="linear"
                  values="0 50 50;360 50 50"
                  keyTimes="0;1"
                  dur="1s"
                  begin="0s"
                  repeatCount="indefinite"
                ></animateTransform>
              </circle></svg
          ></span>
        </div>
      </div>
      <div class="success" v-if="success">
        An email has been sent to <strong>{{ email }}</strong>
      </div>
    </div>
  </div>
</template>
<script>
import AuthenticationService from "@/services/AuthenticationService";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      email: "",
      seen: false,
      loader: false,
      error: {
        email: false,
      },
      show: false,
      post: true,
      success: false,
      message: "",
      exist: "",
    };
  },
  methods: {
    hideError() {
      this.exist = "";
      this.error.email = false;
      this.message = "";
    },
    sendquestion() {
      this.post = true;
      this.message = "";
      this.exist = "";

      if (this.email === "") {
        this.error.email = true;
        this.post = false;
      } else {
        this.error.email = false;
      }

      if (this.post) {
        let that = this;
        this.loader = true;

        let data = {
          token: cookies.getCookie("temp_token"),
          email: this.email,
        };

        AuthenticationService.sendquestion(data)
          .then((res) => {
            let { data } = res;

            if (data.data == true) {
              that.loader = false;
              that.success = true;
            }

            if (data.message == "not exist") {
              that.message = that.email + " does not exist";
              that.loader = false;
            }

            if (data.message == "exist") {
              that.exist = that.email + " is invalid";
              that.loader = false;
            }

            if (data.data == false) {
              that.$router.push("/login");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    send_question(evt) {
      if (evt.keyCode === 13) {
        this.post = true;
        this.message = "";
        this.exist = "";

        if (this.email === "") {
          this.error.email = true;
          this.post = false;
        } else {
          this.error.email = false;
        }

        if (this.post) {
          let that = this;
          this.loader = true;

          let data = {
            token: cookies.getCookie("temp_token"),
            email: this.email,
          };

          AuthenticationService.sendquestion(data)
            .then((res) => {
              let { data } = res;

              if (data.data == true) {
                that.loader = false;
                that.success = true;
              }

              if (data.message == "not exist") {
                that.message = that.email + " does not exist";
                that.loader = false;
              }

              if (data.message == "exist") {
                that.exist = that.email + " is invalid";
                that.loader = false;
              }

              if (data.data == false) {
                that.$router.push("/login");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    load() {
      this.seen = true;
      this.email = "";
      this.message = "";
      this.exist = "";
      this.error.email = "";
    },
    close() {
      this.seen = false;
      this.success = false;
      this.email = "";
    },
  },
};
</script>
